const socialProfileClicked = () => {};

const editProfileFormShow = () => {};

const editProfileFormClose = () => {};

const editProfileFormSave = () => {};

const editProfileFormPicturesValid = () => {};

const editProfileFormNameValid = () => {};

const editProfileFormLastnameValid = () => {};

const editProfileFormBirthdateValid = () => {};

const editProfileFormGenderValid = () => {};

const userTrackingEvents = () => {
  return {
    socialProfileClicked,
    editProfileFormShow,
    editProfileFormClose,
    editProfileFormSave,
    editProfileFormPicturesValid,
    editProfileFormNameValid,
    editProfileFormLastnameValid,
    editProfileFormBirthdateValid,
    editProfileFormGenderValid,
  };
};

export default userTrackingEvents;
